export default async function getIntentExtra() {
    return Promise.resolve(null);
}